// Hook: useInfiniteScroll
// Provides chunked pagination logic for large arrays with intersection observer triggers.
// Returns: { displayedItems, hasMore, loading, loadMore, progress }
import { useState, useCallback, useMemo } from 'react';

export function useInfiniteScroll(items, pageSize = 20) {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const total = items.length;
  const displayedItems = useMemo(() => items.slice(0, page * pageSize), [items, page, pageSize]);
  const hasMore = displayedItems.length < total;
  const progress = total === 0 ? 0 : (displayedItems.length / total) * 100;

  const loadMore = useCallback(() => {
    if (loading || !hasMore) return;
    setLoading(true);
    // Simulate async delay for UX consistency
    setTimeout(() => {
      setPage(p => p + 1);
      setLoading(false);
    }, 250);
  }, [loading, hasMore]);

  return { displayedItems, hasMore, loading, loadMore, progress };
}

export default useInfiniteScroll;
